import BigNumber from 'bignumber.js'
import React, { useCallback, useMemo, useState } from 'react'
import Web3 from 'web3'
import styled from 'styled-components'
import { Text } from '@pancakeswap-libs/uikit'
import Logo from 'components/Logo'
import { sortLpTokens } from 'utils/lpUtils'
import { getChecksumAddress } from 'utils/addressHelpers'

const Container = styled.span`
  display: inline-block;
  white-space: nowrap;
  height: 64px;
  width: 64px;
  position: relative;
`

const Image = styled(Logo)`
  height: 32px;
  width: auto;
  display: inline-block;
  position: absolute;
  z-index: 1;
`

const TokenImage = styled(Image)`
  left: 0;
  top: 0;
`

const BaseTokenImage = styled(Image)`
  right: 0;
  bottom: 0;
`

const BoneImage = styled.img`
  width: 100%;
  height: 100%;
  z-index: 2;
  position: relative;
  display: block;
`

interface IconProps {
    token0: any,
    token1: any
}

const Icon : React.FC<IconProps> = ({ token0, token1 }) => {
    const tokens = sortLpTokens({address: token0}, {address: token1});
    return (
        <Container>
            <BoneImage src="/images/farms/empty.png" alt="Bone" />
            <TokenImage srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(tokens[0].address)}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={`${tokens[0].address} Logo`} />
            <BaseTokenImage srcs={[`https://asset.benswap.cash/assets/${getChecksumAddress(tokens[1].address)}/logo.png`,"/images/UNKNOWNSEP20.png"]} alt={`${tokens[1].address} Logo`} />
        </Container>
    )
}

export default Icon
